var targetFormSubmit = document.getElementById("PostingToSelligentCard")
if (targetFormSubmit != null) {


  targetFormSubmit.addEventListener("submit", function (e) {
    e.preventDefault();
    let email = document.querySelector(".email-fieldCard");
    if (email != null)
      console.log(email);
    email = email.value;
    let societe = document.querySelector(".societe-fieldCard");
    if (societe != null)
      societe = "societe.value";

    console.log("value of societe " + societe);
    let media = document.querySelector(".media-fieldCard");
    if (media != null)
      media = media.value;
    console.log("value of media " + media);

    let theme = document.querySelector(".theme-fieldCard");
    if (theme != null)
      theme = theme.value;
    console.log("value of theme " + theme);

    let requestVerificationToken = document.querySelector("[name =__RequestVerificationToken]").value;
    //console.log("this is the request verification token :" +RequestVerificationToken);
    // Requette Fetch
    let url = "/Newsletter/SignupAjax";
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(
        {
          Email: email,
          Societe: societe,
          Media: media,
          Theme: theme
        }),
      headers: { 'Content-Type': 'application/json; charset=UTF-8', 'X-CSRF-TOKEN': requestVerificationToken }
    })
      .then(r => r.json().then(data => {
        if (r.status !== 200 || data.Ok !== true) {
          var displayInputGroup = document.querySelector(".infoTexte");
          displayInputGroup.setAttribute("style", "display:none;");
          var message = document.querySelector(".inscriptionSuccess");
          message.setAttribute("style", "display:block;");

          message.setAttribute("style", "content:\f26b");
          message.setAttribute("style", "font-family:material-design-iconic-font");
          message.setAttribute("style", "backgroundColor: #d4edda");
          message.innerHTML = "Votre inscription a bien été prise en compte";
          message.setAttribute("style", "color: #fff");

        }
        else {
          var displayInputGroup = document.querySelector(".infoTexte");
          displayInputGroup.setAttribute("style", "display:none;");
          var message = document.querySelector(".inscriptionSuccess");
          message.setAttribute("style", "display:block;");
          message.setAttribute("style", "color: #dff0d8");
          message.setAttribute("style", "backgroundColor: #D0C90F");
          message.innerHTML = "Votre inscription n'a pas été pris en compte !";
        }


      }));
  })
}


//Mise en place d'inscription dans les articles'

var FormId = document.getElementById("PostingToSelligentLight");


if (FormId != null) {

  FormId.addEventListener("submit", function (e) {
    e.preventDefault();
    let email = document.querySelector(".email-field2").value;
    console.log(email + " email que je recupere");

    let societe = document.querySelector(".societe-field2").value;
    console.log(societe + "societe que  je recupere 2");

    //if (societe != null)(societe as HTMLInputElement).value;

    //else
    //  societe = null;



    let media = document.querySelector(".media-field2").value;

    console.log(media + " media que  je recupere 2");


    let theme = document.querySelector(".theme-field2").value;
    console.log(theme + " theme que  je recupere 2");
    //ce lien est tres util pour la récupération d'une valeur d'un input => https://stackoverflow.com/questions/53071851/getting-the-value-from-input-element-in-typescript#:~:text=You%20can%20get%20the%20value%20of%20an%20input%20in%20TypeScript.&text=var%20num%20%3D%20parseFloat((%3CHTMLInputElement,getElementById(%22myValue%22)).
    //let partenaireId = document.querySelector(".partenaireId") as HTMLInputElement;
    //let requestVerificationToken = document.querySelector("[name =__RequestVerificationToken]") as HTMLInputElement;
    // Requette Fetch
    //let url = "/Newsletter/SignupAjax/";
    fetch("/Newsletter/SignupAjax", {
      method: 'POST',
      body: JSON.stringify(
        {
          Email: email,
          Societe: societe,
          Media: media,
          Theme: theme
        }),
      headers: { 'Content-Type': 'application/json; charset=UTF-8' }
    })
      .then(r => r.json().then(data => {
        if (r.status != 404 && data.ok === true) {
          var hide = document.querySelector(".hideAfterSubmit");
          hide.setAttribute("style", "display:none;");
          var message = document.querySelector(".alert-success");
          message.setAttribute("style", "display:block;");
          message.innerHTML = "Votre inscription a bien été prise en compte";
        }
        else {
          var hide = document.querySelector(".hideAfterSubmit");
          hide.setAttribute("style", "display:none;");
          var message = document.querySelector(".alert-warning");
          message.setAttribute("style", "display:block;");
          message.innerHTML = "Votre inscription n'a pas été pris en compte veuillez vérifier votre email !";
        }

      }));
  });
}